import axios from "../config/axios";
import { normalize, schema } from "normalizr";
import { camelizeKeys } from "humps";

const menuSchema = new schema.Entity("menus");
const listSchema = new schema.Entity("lists");
const itemSchema = new schema.Entity("items");
const tagSchema = new schema.Entity("tags");
const orderSchema = new schema.Entity("orders");
const customerDetailSchema = new schema.Entity("customerDetails");
const customerOrderSchema = new schema.Entity("customerOrders", {
  idAttribute: "restaurant__order__id"
});

const openingHourSchema = new schema.Entity("openingHours");
const branchSchema = new schema.Entity("branches");

const restaurantSchema = new schema.Entity("restaurants", {
  openingHours: [openingHourSchema],
  branches: [branchSchema]
});
const customerSchema = new schema.Entity("customers", {
  restaurant: restaurantSchema
});

export const Schemas = {
  CUSTOMER: customerSchema,
  MENUS: [menuSchema],
  LISTS: [listSchema],
  ITEMS: [itemSchema],
  TAGS: [tagSchema],
  ORDER: orderSchema,
  CUSTOMER_DETAIL: [customerDetailSchema],
  CUSTOMER_ORDERS: [customerOrderSchema]
};

export const getMenu = (page = 1, searchValue) => {
  return (dispatch, getState) => {
    dispatch({
      type: "START"
    });
    const { restaurantId, token } = getState().auth;
    const headers = { headers: { Authorization: "JWT " + token } };
    let url = `/menu/?page=${page}&restaurant=${restaurantId}`;
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    axios
      .get(url, headers)
      .then(response => {
        const normalizedData = normalize(
          camelizeKeys(response.data.results),
          Schemas.MENUS
        );
        if (response.data.count) {
          normalizedData["pageCount"] = Math.ceil(response.data.count / 10);
        }
        dispatch({
          type: "SUCCESS",
          payload: normalizedData
        });
      })
      .catch(error => {
        console.log("error: ", error);
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const getList = (id, page = 1, searchValue) => {
  return dispatch => {
    const tagURL = "/tags/";
    let listURL = `/list/?page=${page}&menu=${id}`;
    if (searchValue) {
      listURL = `${listURL}&search=${searchValue}`;
    }
    Promise.all([axios.get(listURL), axios.get(tagURL)])
      .then(([list, tags]) => {
        const normalizedList = normalize(
          camelizeKeys(list.data.results),
          Schemas.LISTS
        );
        const normalizedTags = normalize(
          camelizeKeys(tags.data.results),
          Schemas.TAGS
        );
        const payload = {
          entities: {
            lists: normalizedList.entities.lists,
            tags: normalizedTags.entities.tags
          },
          result: normalizedList.result
        };

        if (list.data.count) {
          payload["pageCount"] = Math.ceil(list.data.count / 10);
        }
        dispatch({
          type: "SUCCESS",
          payload
        });
      })
      .catch(error => {
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const getItems = (id, page = 1, searchValue) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const headers = { headers: { Authorization: "JWT " + token } };
    let url = `/items/?page=${page}&menu=${id}`;
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    axios
      .get(url, headers)
      .then(response => {
        const normalizedData = normalize(
          camelizeKeys(response.data.results),
          Schemas.ITEMS
        );
        if (response.data.count) {
          normalizedData["pageCount"] = Math.ceil(response.data.count / 10);
        }
        dispatch({
          type: "SUCCESS",
          payload: normalizedData
        });
      })
      .catch(error => {
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const getCustomer = () => {
  return (dispatch, getState) => {
      dispatch({type: "START"})
    const { customerId, token } = getState().auth;
    const url = `/customers/${customerId}/`;
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios
      .get(url, headers)
      .then(response => {
        const normalizedData = normalize(
          camelizeKeys(response.data),
          Schemas.CUSTOMER
        );
        dispatch({
          type: "SUCCESS",
          payload: normalizedData
        });
      })
      .catch(error => {
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const getCustomerOrders = (
  page = 1,
  type,
  def_fromDate,
  def_toDate,
  searchValue,
  date
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    let url = `/reports-customer-order-detail/?${
      def_fromDate ? `from_date=${def_fromDate}&` : ""
    }${def_toDate ? `to_date=${def_toDate}&` : ""}${
      type ? `status=${type}&` : ""
    }page=${page}`;
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    if (date && date.from_date) {
      url = `${url}&from_date=${date.from_date}`;
    }
    if (date && date.to_date) {
      url = `${url}&to_date=${date.to_date}`;
    }
    const headers = { headers: { Authorization: "JWT " + token } };
    axios
      .get(url, headers)
      .then(response => {
        const normalizedData = normalize(
          camelizeKeys(response.data.results),
          Schemas.CUSTOMER_ORDERS
        );
        if (response.data.count) {
          normalizedData["pageCount"] = Math.ceil(response.data.count / 10);
        }
        dispatch({
          type: "SUCCESS",
          payload: normalizedData
        });
      })
      .catch(error => {
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const getSingleOrder = id => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    let url = `/reports-customer-rejected-order-detail/${id}`;

    const headers = { headers: { Authorization: "JWT " + token } };
    axios
      .get(url, headers)
      .then(response => {
        const normalizedData = normalize(
          camelizeKeys(response.data.results),
          Schemas.CUSTOMER_ORDERS
        );
        dispatch({
          type: "SUCCESS",
          payload: normalizedData
        });
      })
      .catch(error => {
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const getCSV = (
  page = 1,
  type,
  def_fromDate,
  def_toDate,
  searchValue,
  date
) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    let url = `/reports-customer-order-detail/?${
      def_fromDate ? `from_date=${def_fromDate}&` : ""
    }${def_toDate ? `to_date=${def_toDate}&` : ""}${
      type ? `status=${type}` : ""
    }&page=${page}`;
    if (searchValue) {
      url = `${url}&search=${searchValue}`;
    }
    if (date && date.from_date) {
      url = `${url}&from_date=${date.from_date}`;
    }
    if (date && date.to_date) {
      url = `${url}&to_date=${date.to_date}`;
    }
    return axios({
      url: url,
      method: "GET",
      headers: {
        Authorization: "JWT " + token,
        Accept: "text/csv"
      },
      responseType: "blob"
    });
  };
};

export const getDashboardCSV = date => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    let url = `/reports-customer-detail/`;
    if (date) {
      if (date.from_date) {
        url = `${url}?from_date=${date.from_date}`;
      }

      if (date.to_date) {
        if (date.from_date) {
          url = `${url}&to_date=${date.to_date}`;
        } else {
          url = `${url}?to_date=${date.to_date}`;
        }
      }
    }
    return axios({
      url: url,
      method: "GET",
      headers: {
        Authorization: "JWT " + token,
        Accept: "text/csv"
      },
      responseType: "blob"
    });
  };
};

export const getCustomerDetail = date => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    let url = `/reports-customer-detail/`;
    if (date) {
      if (date.from_date) {
        url = `${url}?from_date=${date.from_date}`;
      }

      if (date.to_date) {
        if (date.from_date) {
          url = `${url}&to_date=${date.to_date}`;
        } else {
          url = `${url}?to_date=${date.to_date}`;
        }
      }
    }
    const headers = {
      headers: { Authorization: "JWT " + token }
    };
    axios
      .get(url, headers)
      .then(response => {
        const normalizedData = normalize(
          camelizeKeys(response.data.results),
          Schemas.CUSTOMER_DETAIL
        );
       
        if (response.data.count) {
          normalizedData["pageCount"] = Math.ceil(response.data.count / 10);
        }
        dispatch({
          type: "SUCCESS",
          payload: normalizedData
        });
      })
      .catch(error => {
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const getCustomerOrder = orderId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const url = `/orders/${orderId}/`;
    const headers = { headers: { Authorization: "JWT " + token } };
    axios
      .get(url, headers)
      .then(response => {
        const normalizedData = normalize(
          camelizeKeys(response.data),
          Schemas.ORDER
        );
        dispatch({
          type: "SUCCESS",
          payload: normalizedData
        });
      })
      .catch(error => {
        dispatch({
          type: "ERROR",
          payload: error
        });
      });
  };
};

export const editList = (id, data) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const headers = { headers: { Authorization: "JWT " + token } };
    const url = `/list/${id}/`;
    return axios.patch(url, data, headers);
  };
};

export const editItem = (id, data) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const headers = { headers: { Authorization: "JWT " + token } };
    const url = `/items/${id}/`;
    return axios.patch(url, data, headers);
  };
};

export const editCustomer = data => {
  return (dispatch, getState) => {
    const { customerId, token } = getState().auth;
    const url = `/customers/${customerId}/`;
    const headers = { headers: { Authorization: "JWT " + token } };
    return axios.patch(url, data, headers);
  };
};



// WEBPACK FOOTER //
// ./src/actions/foodna.js